import React from "react";
import { motion } from "framer-motion";
import { useTranslation, Trans } from "react-i18next";

const HomePage = () => {
    const { t } = useTranslation();

    const vineyardDetails = [
        {
            image: "/beverahills_vigneto_1.jpg",
            textKey: "home.1-home"
        },
        {
            image: "/beverahills_vigneto_3.jpg",
            textKey: "home.2-home"
        },
        {
            image: "/beverahills_vini_tavola.jpg",
            textKey: "home.3-home"
        }
    ];

    return (
        <div>
            <motion.div 
                className="flex flex-col justify-center items-center py-8 bg-rosso rounded-2xl"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <img src="/vettoriale-beverahills-beige.svg" alt={t("home.alt_logo_beverahills")} className="w-40 sm:w-52 md:w-72 xl:w-80" />
                <h1 className="text-2xl sm:text-4xl text-pesca text-center">
                      <Trans
                        i18nKey="home.motto"
                        // Optional: Provide default text if needed, but structure might differ slightly
                        // defaults="Ogni dettaglio conta, <br /> ogni sorso <0>racconta</0>" // Note: index changes if br isn't a component
                        components={{ 
                            1: <span className="corsivo" /> 
                            // if you had <bold>text</bold> in json as <0>text</0> then:
                            // 0: <strong />
                         }}
                    />
                </h1>
            </motion.div>

            <motion.div
                className="flex flex-col justify-center items-center py-8"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
                <div className="text-lg md:text-2xl text-center leading-relaxed text-gray-800">
                <p>
                    <Trans
                        i18nKey="home.descrizione"
                        components={{
                            0: <span className="font-semibold" />,
                            1: <span className="font-semibold" />
                        }}
                    />
                </p>
                </div>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 ">
                {vineyardDetails.map((item, index) => (
                    <motion.div 
                        key={index} 
                        className="flex-col items-center justify-center border-2 border-verde_scuro p-4 rounded-2xl"
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: index * 0.2 }}
                        viewport={{ once: true }}
                    >
                        <img src={item.image} alt={t("home.alt_vigneto_scorcio")} className="rounded-2xl w-full" />
                        <h2 className="text-center font-medium text-xl sm:text-2xl pt-4 md:text-2xl text-verde_scuro">
                            {t(item.textKey)}
                        </h2>
                    </motion.div>
                ))}
            </div>

            <div className="grid md:pt-8 grid-cols-1 gap-6 md:gap-0 pt-32 md:grid-cols-2" >
                <motion.div 
                    className="relative flex items-center justify-center"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                     <h2 className="text-2xl text-center border-2 border-verde_scuro bg-verde_scuro text-verde_chiaro font-medium p-4 rounded-2xl">
                        <Trans
                            i18nKey="home.ettari"
                            components={{
                                0: <span className="relative z-20" />,
                                1: <span className="text-pesca" />
                                // i18next gestirà i <br /> dalla stringa JSON
                            }}
                        />
                    </h2>
                    <img src="/lago.svg" alt={t("home.alt_lago_icona")} className="absolute -mt-72 md:-mt-60 lg:-mt-72 opacity-50" />
                </motion.div>
                <motion.video 
                    className="rounded-2xl" 
                    controls 
                    muted 
                    autoPlay
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <source src="/VideoVigneto.mp4" type="video/mp4" />
                    {t("home.video_fallback")}
                </motion.video>   
            </div>
        </div>
    );
};

export default HomePage;